import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ninth-page',
  templateUrl: './ninth-page.component.html',
  styleUrls: ['./ninth-page.component.css']
})
export class NinthPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
